import React from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import ReCAPTCHA from "react-google-recaptcha";
import { Modal } from "bootstrap";
import { extrasFormSchema } from '@/schema'
import { useStore, actions } from '@/store'
import { privacyOfficers } from '@/lib/settings'
import RadioGroup from '@/Shared/Form/RadioGroup'
import Input from '@/Shared/Form/Input'
import DatePickerInput from '@/Shared/Form/DatePickerInput'
import { WizardButtons } from '@/Wizard';
import request from '@/api/request';
import { GenerateButton, PrevButton, ResetButton } from '@/Shared/Buttons';
import DecisionMaking from './DecisionMaking';
import SupervisoryAuthority from './SupervisoryAuthority';

const Extras = ({ stepName }) => {
  const [
    extrasFormValue,
    setExtrasFormValue
  ] = useStore(state => [state.extrasFormValue, state.setExtrasFormValue])
  const tokenFlag = useStore(state => state.tokenFlag)
  const setTokenFlag = useStore(state => state.setTokenFlag)
  const iframe = useStore(state => state.iframe)
  const staging = useStore(state => state.staging)
  const [isShowPrivacyOfficerInfo, setIsShowPrivacyOfficerInfo] = React.useState(false)
  const [modal, setModal] = React.useState(null)
  const exampleModal = React.useRef()

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    defaultValues: extrasFormValue,
    resolver: yupResolver(extrasFormSchema),
  });

  const privacyOfficer = useWatch({
    control: formMethods.control,
    name: 'privacyOfficer',
  })

  React.useEffect(() => {
    setIsShowPrivacyOfficerInfo(privacyOfficer.id !== 'noPerson')
  }, [privacyOfficer])


  React.useEffect(() => {
    setModal(
      new Modal(exampleModal.current)
    )
  }, [])

  const onSubmit = (data) => {
    setExtrasFormValue(data)
    if (tokenFlag || iframe || staging) {
      actions.handleWizardNextStep()
      actions.handleWizardPreviewStep() 
    } else {
      modal.show()
    }
  }

  const onChangeCaptcha = token => {
    console.log('Check v2')
    request.post('api/privacy-policy/ui/verify_cap', {
      token: token,
      version: 2,
    }).then(response => {
      if (response.data.isValid) {
        setTokenFlag(true);
        modal.hide();
        actions.handleWizardNextStep();
        actions.handleWizardPreviewStep();
      } else {
        setTokenFlag(false);
      }
    }).catch(error => {
      console.log(error, 'error');
    })
  }

  return (
    <React.Fragment>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <div className="card shadow-lg">
            <div className="card-header">
              <h3 className="card-title">
                Almost done, just tell us about your cookie categories and who will handle privacy requests.
              </h3>
            </div>
            <div className="card-body">
              <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>Do you use automated decision-making (including profiling) that has legal
                    or similarly significant effects on individuals?
                  </p>
                  <DecisionMaking />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>Right to Lodge a Complaint with a Supervisory Authority:</p>
                  <SupervisoryAuthority />
                </div>
              </div>
              <div className='row mt-10'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>Do you have a person who will handle privacy-related questions and issues?</p>
                  <div className='d-flex flex-column'>
                    <RadioGroup
                      options={privacyOfficers}
                      name='privacyOfficer'
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.label}
                      returnValueHowOption={true}
                    />
                  </div>
                </div>
                {isShowPrivacyOfficerInfo &&
                  <div className='col-lg-6 col-md-6 col-sm-12'>
                    <p className='fw-bold'>Privacy Officer/Data Protection Officer contact details</p>
                    <div className="mb-3">
                      <Input
                        labelText='Name'
                        name='officerName'
                        type='text'
                        isRequired
                      />
                    </div>
                    <div className="mb-3">
                      <Input
                        labelText='Email'
                        name='officerEmail'
                        type='email'
                        isRequired
                      />
                    </div>
                    <div className="mb-3">
                      <Input
                        labelText='Phone Number'
                        name='officerPhone'
                        type='text'
                      />
                    </div>
                  </div>
                }
              </div>
              <div className='row mt-4'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold required'>What is the effective date of this Privacy Policy?</p>
                  <div className='col-lg-6 col-md-6 col-sm-12'>
                    <DatePickerInput
                      name='effectiveDate'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer'>
              <WizardButtons>
                <PrevButton onClick={() => actions.handleWizardPrevStep()} />
                <ResetButton onClick={() => actions.handleWizardReset()} />
                <GenerateButton type='submit' />
              </WizardButtons>
            </div>
          </div>
        </form>
      </FormProvider>
        <div className="modal fade" ref={exampleModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex justify-content-center">
                  {!iframe && !staging &&
                    <ReCAPTCHA
                      sitekey="6LemmK4cAAAAAIl_CiNkmgnkp1xYMaCgxY1QH0bL"
                      onChange={onChangeCaptcha}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
    </React.Fragment>
  )
}

export default Extras